import React, { useContext, useState } from 'react';
import Axios from 'axios';
import { Container, ImportFileHeader, TemplateLink } from './LoadFile.styles';
import config from '../../config';
import AppContext from '../../AppContext';
import { renderWithPermissions } from '../../Components/Auth0/permissionFunctions';
import Auth0SessionInfo from '../../Services/Auth0SessionInfo';
import GrpDropFile from '../../Library/GrpDropFile/GrpDropFile';

const uploadApiUrl = config.dip.url;

const LoadFile = () => {
  const context = useContext(AppContext);
  const [files, setFiles] = useState([]);
  const [queuedFileMessage, setQueuedFileMessage] = useState('');

  const getTemplate = () => {
    if (context.state.selectedClient.type === 'INS') {
      return ('../DFIN_Ins_Ingestion_Template.xlsx');
    }
    return ('../DFIN_Ingestion_Template.xlsx');
  };

  const handleInputChange = (acceptedFiles) => {
    const newFiles = [...files, ...acceptedFiles];
    setFiles(newFiles);

    const fileCount = newFiles.length;
    const s = fileCount > 1 ? 's' : '';
    const av = fileCount > 1 ? 'are' : 'is';
    const message = fileCount > 0 ? `${fileCount} File${s} ${av} queued for upload.` : '';
    setQueuedFileMessage(message);
  };

  const uploadFile = async (file) => {
    const lastIndex = file.name.lastIndexOf('.');
    const fileExtension = lastIndex > 0 ? file.name.substr(lastIndex + 1) : '';
    const fileNameOnly = lastIndex > 0 ? file.name.substr(0, lastIndex) : file.name;

    const data = new FormData();
    data.append('data', file);
    data.append('filename', fileNameOnly);
    data.append('clientCode', context.state.selectedClient.code);
    data.append('extension', fileExtension);
    data.append('template', 'GFI');

    return Axios.post(uploadApiUrl, data, {
      headers: {
        authorization: `Bearer ${Auth0SessionInfo.GetSessionInfo().accessToken}`,
      },
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (files.length === 0) {
      const toast = {
        type: 'info',
        body: (<>No files selected for upload.</>),
      };
      context.handlers.setToast(toast);
      return;
    }

    const fileCount = files.length;
    const s = fileCount > 1 ? 's' : '';
    setQueuedFileMessage(`Uploading ${fileCount} file${s}...`);

    try {
      await Promise.all(files.map((file) => uploadFile(file)));

      const toast = {
        type: 'success',
        body: (
          <>
            {'Successfully uploaded '}
            <span>{fileCount}</span>
            {` file${s}`}
          </>
        ),
      };
      context.handlers.setToast(toast);
    } catch (err) {
      console.error('Upload error:', err);
      const toast = {
        type: 'error',
        body: (
          <>
            {'Error uploading files. Please try again.'}
          </>
        ),
      };
      context.handlers.setToast(toast);
    }

    setFiles([]);
    setQueuedFileMessage('');
  };

  const dropzoneProps = {
    zone: 'LoadFile',
    message: `Drag Files or Click to add to ${context.state.selectedClient.name}`,
    queuedFileMessage,
    handleInputChange,
    handleSubmit,
    acceptedFiles: {
      'application/vnd.ms-excel': ['.xls'],
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
      'text/csv': ['.csv'],
    },
    maxFiles: 100,
  };

  const yes = () => (
    <Container>
      <div>
        <ImportFileHeader>How to Import a File</ImportFileHeader>
        <p>
          {'Start with DFIN\'s '}
          <TemplateLink href={getTemplate()} download>
            Global Filing Template
          </TemplateLink>
          .  Fill it out and drag and drop below!
        </p>
      </div>
      <GrpDropFile {...dropzoneProps} />
    </Container>
  );
  return renderWithPermissions(yes);
};

export default LoadFile;
